import Helper from "./Helper";
import Swiper from "../lib/swiper";
import swiper from "../lib/swiper";

class Slider {
  constructor(config = {}) {
    const {} = config;

    this.sliders = document.querySelectorAll('.swiper-container');
    this.swiperInstance = null;
    this.initSwiper(config);
  }

  initSwiper(config) {
    this.swiperInstance = new Swiper('.swiper-container', {
      loop: true,
      slidesPerView: 1,
      effect: 'fade',
      autoplay: {
        delay: 10000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }
}

export default Slider;
